import React, { useState, useEffect } from "react";
import { Box, TextField, Typography } from "@mui/material";

import AppProvider from "./AppProvider";
// import Header from "./components/Header";
import Footer from "./components/Footer";
import ViewFiles from "./pages/ViewFiles";
import "./App.css";
import BillForm from "./components/BillForm";
import PlanNotAvailable from "./components/PlanNotAvailable";
import { createUser, optimalPlan } from "./api/APIs";
import SplashScreen from "./components/SplashScreen";
import Available from "./components/Available";
import LeftText from "./components/LeftText";
import CustomizedSnackbars from "./components/Alert";
import { useCookies } from "react-cookie";
import { HeaderV2 } from "./components/header_v2/Header";

const App = () => {
  const [showForm, setShowForm] = useState(false);
  const [notAvailable, setNotAvailable] = useState(false);
  const [available, setAvailable] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [showLoader, setShowloader] = useState(false);
  const [optimalPlans, setOptimalPlan] = useState([]);

  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState(
    "Something went wrong. Please try again"
  );

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <AppProvider>
      {showLoader ? (
        <SplashScreen loading={showLoader} />
      ) : (
        <>
          <HeaderV2/>
          {/* <Header /> */}
          {/* <Box id="form"></Box> */}
          {notAvailable ? (
            <PlanNotAvailable
              setNotAvailable={setNotAvailable}
              setShowForm={setShowForm}
            />
          ) : available ? (
            <Available
              setNotAvailable={setNotAvailable}
              setAvailable={setAvailable}
              setShowForm={setShowForm}
              optimalPlans={optimalPlans}
              setOptimalPlan={setOptimalPlan}
              setUserInfo={setUserInfo}
            />
          ) : (
            <>
              <Box
                m={{ xs: "5% 5% 10% 5%", lg: "5% 5% 10% 5%" }}
                sx={{
                  height: "auto",
                  // width: "100%",
                  display: "flex",
                  flexDirection: showForm
                    ? {
                        xs: "column-reverse",
                        lg: "row",
                      }
                    : {
                        xs: "column",
                        lg: "row",
                      },
                  justifyContent: "space-between",
                  alignItems: {xs:"center", lg:'stretch'},
                }}
              >
                {showForm ? (
                  <BillForm
                    userInfo={userInfo}
                    setNotAvailable={setNotAvailable}
                    setShowloader={setShowloader}
                    setAvailable={setAvailable}
                    setOptimalPlan={setOptimalPlan}
                    optimalPlans={optimalPlans}
                    setShowForm={setShowForm}
                    handleClick={handleClick}
                  />
                ) : (
                  <LeftText />
                )}
                <ViewFiles
                  setShowForm={setShowForm}
                  setUserInfo={setUserInfo}
                  showForm={showForm}
                />
              </Box>
            </>
          )}
          <CustomizedSnackbars
            open={open}
            message={message}
            handleClose={handleClose}
          />
          <Footer />
        </>
      )}
    </AppProvider>
  );
};

export default App;
